type CarouselItemProps = {
	children?: React.ReactNode;
	onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

/**
 * Internal slider component, controls that all items can have the same height and a generic onClick event
 */
const CarouselItem: React.FC<CarouselItemProps> = ({ children, onClick }) => (
	// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
	<div className="carousel-item" data-carousel-item="1" onClick={onClick}>
		{children}
	</div>
);

export default CarouselItem;
